import * as React from "react";
import styled from "styled-components";

import { Card } from "../../../../components/atoms";
import { Container } from "../../../../components/grid";
import { theme } from "../../../../theme";

interface IProps {
  isShown: boolean;
  style: React.CSSProperties;
  children?: React.ReactNode;
}

const BreadcrumbsBar: React.FC<IProps> = (props) => {
  const TransitionWrapper = styled.div``;

  const BreadcrumbsWrapper = Card.extend`
    position: fixed;
    width: 100%;
    height: 56px;
    border-bottom: 1px solid ${theme.color.ruubyGreyBg};
    border-radius: 0;
    overflow: auto;
    z-index: 998;
  `;

  const BreadcrumbsBarStyledContainer = Container.extend`
    display: flex;
    padding: 0 2%;

    @media screen and (max-width: 992px) {
      justify-content: flex-start;
      padding: 0 0 0 2%;
    }

    > * {
      &:first-child {
        padding-left: 0;

        @media screen and (max-width: 992px) {
          padding-left: 10px;
        }
      }
    }
  `;

  const FilterBreadcrumbsPusher = styled.div`
    height: 56px;
  `;

  return (
    <TransitionWrapper style={props.style}>
      <BreadcrumbsWrapper>
        <BreadcrumbsBarStyledContainer>
          {props.children}
        </BreadcrumbsBarStyledContainer>
      </BreadcrumbsWrapper>

      {props.isShown && <FilterBreadcrumbsPusher />}
    </TransitionWrapper>
  );
};

export { BreadcrumbsBar };
